(function () {
  // Mirrors the PowerX checkout function: keep the free GWP variant in the
  // cart whenever the (non-gift) subtotal is >= the threshold, remove it when
  // it drops below, and never create a duplicate line.
  var CONFIG = {
    variantId: 45353877504179, // Gift with Purchase - Itty Bitty Heart Necklace
    thresholdCents: 5000, // $50.00 in store currency (USD); converted to the visitor's presentment currency at runtime
    reAddAfterManualRemoval: true, // set false to respect a customer's manual removal for the session
    // Same marker the PowerX checkout function stamps on its gift line, so it
    // recognizes our line as its own and doesn't add a duplicate at checkout
    // (and Shopify merges the lines if it ever does).
    lineProperties: { _powerx_auto_add: 'true' }
  };

  var ADDED_KEY = 'jm_gwp_added';
  var DISMISSED_KEY = 'jm_gwp_dismissed';

  var busy = false;
  var pending = false;
  var addBlocked = false; // set after a failed add (e.g. gift out of stock) to avoid retry loops

  function getFlag(key) {
    try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; }
  }

  function setFlag(key, value) {
    try { sessionStorage.setItem(key, value ? '1' : '0'); } catch (_) {}
  }

  function refreshCartUi() {
    // Rebuy Smart Cart doesn't watch external AJAX cart changes; the documented
    // way to sync it is SmartCart.setCart() with a fresh Shopify cart object.
    fetch('/cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        try {
          if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.setCart === 'function') {
            window.Rebuy.SmartCart.setCart(cart);
          }
        } catch (_) {}
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: CONFIG.variantId, quantity: 1, properties: CONFIG.lineProperties }] })
    }).then(function (r) {
      if (!r.ok) {
        addBlocked = true;
        return false;
      }
      setFlag(ADDED_KEY, true);
      setFlag(DISMISSED_KEY, false);
      return true;
    });
  }

  function cartUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.ok;
    });
  }

  function propCount(line) {
    return line.properties ? Object.keys(line.properties).length : 0;
  }

  function consolidateGiftLines(giftLines) {
    // The checkout function adds its gift as a separate line (marked with its
    // own line item properties, so Shopify doesn't merge it with ours). Keep
    // the most-marked line — the one the checkout function recognizes as its
    // own — and drop the rest, so it won't re-add on the next checkout visit.
    var keep = giftLines.reduce(function (best, line) {
      return propCount(line) > propCount(best) ? line : best;
    }, giftLines[0]);
    var updates = {};
    giftLines.forEach(function (line) {
      updates[line.key] = line === keep ? 1 : 0;
    });
    return cartUpdate(updates);
  }

  function removeGiftLines(giftLines) {
    var updates = {};
    giftLines.forEach(function (line) {
      updates[line.key] = 0;
    });
    return cartUpdate(updates).then(function (ok) {
      if (ok) setFlag(ADDED_KEY, false);
      return ok;
    });
  }

  function thresholdInPresentmentCents() {
    // cart.js prices come back in the visitor's presentment currency (e.g. RON),
    // so convert the USD threshold with Shopify's own market rate.
    var rate = 1;
    try {
      var raw = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
      var parsed = parseFloat(raw);
      if (parsed > 0) rate = parsed;
    } catch (_) {}
    return Math.round(CONFIG.thresholdCents * rate);
  }

  function decideAction(cart) {
    var giftLines = [];
    var giftPriceCents = 0;
    var giftQuantity = 0;
    (cart.items || []).forEach(function (item) {
      if (item.variant_id === CONFIG.variantId) {
        giftLines.push(item);
        giftPriceCents += item.final_line_price || 0;
        giftQuantity += item.quantity || 0;
      }
    });

    var eligible = (cart.total_price - giftPriceCents) >= thresholdInPresentmentCents();

    if (eligible && !giftLines.length) {
      if (addBlocked) return null;
      if (getFlag(ADDED_KEY) && !CONFIG.reAddAfterManualRemoval) {
        // Gift was in the cart earlier this session and we didn't remove it:
        // treat as a manual removal and respect it.
        setFlag(DISMISSED_KEY, true);
      }
      if (!CONFIG.reAddAfterManualRemoval && getFlag(DISMISSED_KEY)) return null;
      return addGift;
    }

    if (eligible && (giftLines.length > 1 || giftQuantity > 1)) {
      // Dedupe insurance: a duplicate from the checkout function shows up as
      // either quantity > 1 (merged) or a second separate line (unmerged,
      // when it carries its own line item properties).
      return function () { return consolidateGiftLines(giftLines); };
    }

    if (!eligible && giftLines.length) {
      return function () { return removeGiftLines(giftLines); };
    }

    return null;
  }

  function evaluate() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;

    fetch('/cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      })
      .then(function (cart) {
        var action = decideAction(cart);
        if (!action) return false;
        return action();
      })
      .then(function (mutated) {
        if (mutated) refreshCartUi();
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) {
          pending = false;
          evaluate();
        }
      });
  }

  // Run on load and on any cart update event (same wiring as returns-cart-exclude.js)
  document.addEventListener('DOMContentLoaded', evaluate);
  ['cart:updated', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (e) {
    document.addEventListener(e, evaluate);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') evaluate();
  });
})();
